import { selectActivePackageServiceId } from './selectActivePackageServiceId';
import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';
import { selectActivePlacingType } from './selectActivePlacingType';
import { PROMOTION_SERVICES } from '../../constants/services';

export function selectIsPromotionPackageSelected(state: IAppState): boolean {
  const activePackageServiceId = selectActivePackageServiceId(state);
  const placingType = selectActivePlacingType(state);

  return (
    placingType === EPlacingType.package &&
    !!activePackageServiceId &&
    PROMOTION_SERVICES.includes(activePackageServiceId)
  );
}
